import {createContext} from 'react';
import {FilterContextType} from 'types/filterContext';


export const FilterContext = createContext<FilterContextType>({
    apiFilters: {
        environment: 'dev',
        region: 'us',
    },
    setApiFilters: () => {
    }
});




